import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    registration: {
      id: null,
      email: '',
      name: null,
      company: null
    }
  },
  getters: {
    getEmail: state => state.registration.email,
    getName: state => state.registration.name,
    getCompany: state => state.registration.company,
  },
  mutations: {
    SET_EMAIL: (state, email) => {
      state.registration.email = email
    },
    SET_NAME: (state, name) => {
      state.registration.name = name
    },
    SET_COMPANY: (state, company) => {
      state.registration.company = company
    },
    SET_ID: (state, id) => {
      state.registration.id = id
    },
  },
  actions: {
    submit({state, commit}, {email = null, name = null, company = null, isSubmitted = 0}) {
      return new Promise((resolve, reject) => {
        let data = {
          is_submitted: isSubmitted
        };

        if(email !== null) data.email = email;
        if(name !== null) data.name = name;
        if(company !== null) data.company = company;

        let response;

        if(state.registration.id !== null && !isNaN(state.registration.id)) {
          response = axios.patch(`${process.env.VUE_APP_ADMIN_URL}/api/registrations/${state.registration.id}`, data);
        } else {
          response = axios.post(`${process.env.VUE_APP_ADMIN_URL}/api/registrations`, data);
        }

        response
            .then(response => response.data)
            .then(registration => {
              commit('SET_ID', registration.id);
              commit('SET_NAME', registration.name);
              commit('SET_COMPANY', registration.company);
              resolve(registration)
            })
            .catch(error => {
              reject(error)
            });
      })
    }
  },
  modules: {
  }
})
